/**
 * @generated SignedSource<<d77c2529ebcba054fd9c44d74f36ec5f>>
 * @relayHash b699922fcff63a4be96bc66e3427eb04
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 99156033eb08c9db7684b93afc5fe6b4cc00d136db741258c350c6603148d19d

import type { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
export type RealtimeUpdater834BadPatternSubscription$variables = {
  cloudId: string;
  projectId: string;
};
export type RealtimeUpdater834BadPatternSubscription$data = {
  readonly jira: {
    readonly onIssueDeletedByProject: {
      readonly resource: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type RealtimeUpdater834BadPatternSubscription = {
  response: RealtimeUpdater834BadPatternSubscription$data;
  variables: RealtimeUpdater834BadPatternSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectId"
  }
],
v1 = [
  {
    "concreteType": "JiraSubscription",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          },
          {
            "kind": "Variable",
            "name": "projectId",
            "variableName": "projectId"
          }
        ],
        "concreteType": "JiraIssueDeletedStreamHubPayload",
        "kind": "LinkedField",
        "name": "onIssueDeletedByProject",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "resource"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "RealtimeUpdater834BadPatternSubscription",
    "selections": (v1/*: any*/),
    "type": "Subscription"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RealtimeUpdater834BadPatternSubscription",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "99156033eb08c9db7684b93afc5fe6b4cc00d136db741258c350c6603148d19d",
    "metadata": {},
    "name": "RealtimeUpdater834BadPatternSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "c28881ef91dcd6d6c776178574d09fba";

export default node;
